import React, {Component} from "react"
import {Entity} from "aframe-react"

import SkyBox from '../assets/bg.png'

import Backgrond1 from "../assets/backgrounds/de7210d05da8121f74aae2397de48b96.jpg"
import Backgrond2 from "../assets/backgrounds/panorama-360-nordic-style-family-bedroom-space-01-3d-model-max.jpg"
import Backgrond3 from "../assets/backgrounds/panorama-360-nordic-style-living-room-dining-room-01-3d-model-max.jpg"
import Backgrond4 from "../assets/backgrounds/panorama-360-nordic-style-living-room-dining-room-10-3d-model-max.jpg"
import Backgrond5 from "../assets/backgrounds/Warehouse-with-lights.jpg"
import Backgrond6 from "../assets/backgrounds/equirectangular-final.jpg"

import frameButton from "../components-aframe/frameButton"

import 'aframe-animation-component';

import aframe from "aframe"
import { LineDashedMaterial } from "three"

aframe.registerShader("lines-dashed", {
    schema: {
        lineWidth: {default: 1},
        dashSize: {default: 3}
    },

    init: function (data) {
        this.material = new LineDashedMaterial(data)
        this.update(data)
    },

    update: function (data) {
        this.material.lineWidth = data.lineWidth
        this.material.dashSize = data.dashSize
    }
})

class MainSphere extends Component {

    constructor(props) {
        super(props)

        this.bgs = [Backgrond1, Backgrond2, Backgrond3, Backgrond4, Backgrond5]

        this.state = {
            cur: 0,
            visible: false,
        }

        document.addEventListener("keypress", this.keyUp.bind(this))
    }

    keyUp(e) {
        console.log(e.charCode)

        const code = e.charCode
        if (code < 48 || code > 59) return
        
        const i = code - 49
        console.log(i)
        if (i === -1) { 
            this.setState({ visible: false })
            return
        }
        if (i >= this.bgs.length) return
        
        this.setState({
            cur: i,
            visible: true,
        })
    }

    render() {
        return (
            <Entity>

                  <Entity
                    geometry={{
                        primitive: "sphere",
                        radius: 15,
                        segmentsHeight: 16, //10,
                        segmentsWidth: 32 //16,

                    }}

                    position={{
                        x: 0, y: 0, z: 0
                    }}

                    // material={{ color: "#FAFAFA", side: "back", shader: "flat", wireframe: true, wireframeLinewidth: 1 }}
                    // material={{ color: "#fff", side: "back", shader: "flat" }}
                    material={{ src: Backgrond6, side: "back", shader: "flat" }}
                    // material={{ shader: "lines-dashed" }}

                    scale={{x: 2, y: 2, z: 2}}

                    events={{
                        clickUp: () => {
                            console.log("UNIVERSAL CLICKING ON SPHERE");
                            this.props.startSpeech();
                        }
                    }}

                    frame-button={{
                        button: true,
                        cursorFeedback: false,
                    }}

                />  

                 {/* <Entity
                    geometry={{
                        primitive: "circle",
                        radius: 18,
                    }}

                    material={{
                        color: "#fcfcfc",
                        // color: "#424242", 
                        
                        shader: "flat",
                        side: "front",
                    }}

                    rotation={{x: -90, y: 0, z: 0}}
                    position={{x: 0, y: -7, z: 0}}

                    scale={{x: 2, y: 2, z: 1}}

                    visible={!this.state.visible}
                />  */}

                

            </Entity>
        )
    }
}

export default MainSphere



// WEBPACK FOOTER //
// ./src/components/main-sphere.js